const SideNav = (
  state = {
    isNavVisible: !localStorage.getItem('netacad-SideNav-isVisible')
      ? true
      : localStorage.getItem('netacad-SideNav-isVisible') === 'true'
      ? true
      : false
  },
  action
) => {
  switch (action.type) {
    case 'TOGGLE_SIDE_NAV':
      localStorage.setItem('netacad-SideNav-isVisible', !state.isNavVisible);
      return {
        ...state,
        isNavVisible: !state.isNavVisible
      };
    default:
      if (!localStorage.getItem('netacad-SideNav-isVisible')) {
        localStorage.setItem('netacad-SideNav-isVisible', true);
      }
      return state;
  }
};
export default SideNav;
